// ABOUTME: Workflow create wizard route. Renders WorkflowWizard.

import { WorkflowWizard } from "@/components/workflows/WorkflowWizard";
import { supabase } from "@/contexts/AuthContext";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { jwtDecode } from "jwt-decode";

interface JWTPayload {
  user_role?: string;
}

export const Route = createFileRoute("/_authenticated/skills/workflows/new")({
  beforeLoad: async () => {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    if (!session?.access_token) {
      throw redirect({ to: "/login" });
    }
    const decoded = jwtDecode<JWTPayload>(session.access_token);
    if (decoded.user_role !== "superadmin") {
      throw redirect({ to: "/skills" });
    }
  },
  component: WorkflowWizard,
});
